import React, { createContext, useContext, useEffect, useState } from 'react';

const AccessibilityContext = createContext();

const initial = {
  fontSize: 16,

  highlightLinks: false,
  stopAnimations: false,
  imagesOff: false,
  biggerCursor: false,

  readingRuler: false,
  readingMask: false,
  reader: false,

  lineHeight: 0,
  letterSpacing: 0,
  contrastMode: 0,
};

const AccessibilityProvider = ({ children }) => {
  const [opened, setOpened] = useState(false);

  const [config, _setConfig] = useState(initial);

  const setConfig = (key, value) => {
    const newConfig = {
      ...config,
      [key]: value,
    };

    _setConfig(newConfig);
    localStorage.setItem('accessibility-config', JSON.stringify(newConfig));
  };

  const resetConfig = () => {
    _setConfig(initial);
    localStorage.removeItem('accessibility-config');
  };

  useEffect(() => {
    const retrieved = localStorage.getItem('accessibility-config');
    if (!retrieved) return;

    _setConfig(JSON.parse(retrieved));
  }, []);

  return (
    <AccessibilityContext.Provider
      value={{ opened, setOpened, config, setConfig, resetConfig }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};

export default AccessibilityProvider;

const useAccessibilityContext = () => useContext(AccessibilityContext);

export { useAccessibilityContext };
